export default "__VITE_ASSET__f4785c13__"